export const BASE_URL = "https://139.59.4.226:8443/chordsnepal/api";
// export const BASE_URL = "http://localhost:8080/api";

// ChordsNepal
// export const CLOUDINARY_URL = 'https://res.cloudinary.com/dzubzqlj3/image/upload/';
export const CLOUDINARY_CHORDS_URL = 'https://res.cloudinary.com/dzubzqlj3/raw/upload/chords/';

// NepalCommerce
export const CLOUDINARY_URL = 'https://res.cloudinary.com/det0jwdx5/image/upload/';
